import { Component, ViewEncapsulation, Input, EventEmitter, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';
import { Subscription } from 'rxjs';

import { DatacenterType } from '../../../models/datacenter-aggrid-view';
import { UNDERSCORE } from '../../../utils/constant';
import { Document } from '../../../../commercial-documents/models/document';
import { DocumentService } from '../../../../commercial-documents/services/documents.service';
import { OrderService } from '../../../../order/services/order.service';
import { BatchesService } from '../../../../order/services/batches.service';
import { SafeUrlPipe } from '../../../pipes/safeurl.pipe';
import { DatePipe } from '../../../pipes/date.pipe';
import { LoadingSpinnerComponent } from '../../utils/loading-spinner.component';
import { Batch } from '../../../../order/models/batch';
import { Order } from '../../../../order/models/order';
import { DatacenterDefaultConfiguration } from '../../../datacenter/datacenter-default-configuration';
import { ScheduleBusinessOrder } from '../../../../order/models/schedule-business-order';
import { ORDER_REDIRECT_URL,
	ScheduleBusinessOrderService } from '../../../../order/services/schedule-business-order.service';
import { UserService } from '../../../services/user.service';

@Component({
	selector: 'copo-result-certificate-card',
	templateUrl: './result-card-certificate.component.html',
	styleUrl: './result-card-certificate.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		MatIconModule,
		MatRippleModule,

		MatButtonModule,
		TranslateModule,
		RouterLink,
		NgFor,
		LoadingSpinnerComponent,
		DatePipe,
		SafeUrlPipe
	]
})
export class ResultCardCertificateComponent implements OnInit, OnDestroy {
	@HostBinding('class.passthrough') readonly passthrough = true;

	@Input() document?: Document;
	createFilter = new EventEmitter<{ document: Document; filterType: DatacenterType }>();
	readonly UNDERSCORE = UNDERSCORE;
	batch?: Batch;
	order?: Order;
	scheduleBusinessOrderRequiredFields: (keyof ScheduleBusinessOrder)[] = ['supplierOrderType'];
	scheduleBusinessOrder?: Subscription;
	hasSBOrderService = false;

	constructor(
		private readonly documentService: DocumentService,
		private readonly orderService: OrderService,
		private readonly batchService: BatchesService,
		private readonly defaultConfiguration: DatacenterDefaultConfiguration,
		private readonly scheduleBusinessOrderService: ScheduleBusinessOrderService,
		private readonly userService: UserService
	) {
		const { user } = this.userService;
		this.hasSBOrderService = user.hasServiceParameterEqualsTo('PORDT', 'SBOrder', 'True');
	}

	downloadDocument(id: number, filename: string) {
		return this.documentService.getDownloadDocumentUrl(id, filename);
	}

	getDocumentURL(id: number, filename: string) {
		return this.documentService.getViewDocumentUrl(id, filename);
	}

	async redirectToBatchDatacenter(document: Document) {
		await this.batchService.batchDatacenterFilter(document, this.defaultConfiguration.getDefaultView('batch'));
	}

	ngOnInit(): void {
		if (this.document) {
			if (this.hasSBOrderService) {
				this.scheduleBusinessOrderService.setRedirectionLink(
					this.document,
					this.scheduleBusinessOrderRequiredFields
				);
			} else {
				this.document.isSbOrder = false;
				this.document.docNavigationLink = ORDER_REDIRECT_URL;
			}
		}
	}

	async redirectToOrderDatacenter(document: Document) {
		if (document.isSbOrder) {
			await this.scheduleBusinessOrderService.sbOrderDatacenterFilter(
				document,
				this.defaultConfiguration.getDefaultView('schedule-business-order')
			);
			return;
		}
		await this.orderService.orderDatacenterFilter(
			document,
			this.defaultConfiguration.getDefaultView('order')
		);
	}

	ngOnDestroy() {
		this.scheduleBusinessOrder?.unsubscribe();
	}
}
